import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TwBackdrop from '../TwBackdrop/TwBackdrop';
import TwDialog from '../TwDialog/TwDialog';

interface LoadingInvoiceServiceModalProps {
  open: boolean;
  isFetching: boolean;
  isLoading: boolean;
  error: boolean;
}

export const LoadingInvoiceServiceModal: React.FC<LoadingInvoiceServiceModalProps> = ({
  open,
  isFetching,
  isLoading,
  error = false
}) => {
  return (
    <TwDialog
      open={open}
      title={`Loading Invoice Services`}
      actionsAlignment="flex-end"
      actions={[]}
    >
      <Box>
        {error && !isFetching && !isLoading && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Typography
              variant="h6"
              fontSize="18px"
              sx={{ mt: 2, color: 'text.secondary', textAlign: 'center' }}
            >
              There was an error loading the invoice services. Please try again.
            </Typography>
          </Box>
        )}
        {(isFetching || isLoading) && (
          <>
            <TwBackdrop isOpen={true} />
            <Typography
              variant="h6"
              fontSize="18px"
              sx={{ mt: 2, color: 'text.secondary', textAlign: 'center' }}
            >
              Loading invoice services ...
            </Typography>
          </>
        )}
      </Box>
    </TwDialog>
  );
};
